(function () {
  "use strict";

  var cartOpen = false;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // ─── Cart data ────────────────────────────────────────────────────

  async function refreshCartCount() {
    var badge = document.querySelector(".cart-quantity");
    try {
      var res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      var cart = await res.json();
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? "block" : "none";
      }
      var el = document.querySelector(".cart-drawer-item-count");
      if (el) {
        el.textContent = cart.item_count + (cart.item_count === 1 ? " ITEM" : " ITEMS");
      }
      updateFreeShippingProgress(cart);
    } catch (e) { /* silent */ }
  }

  function updateFreeShippingProgress(cart) {
    var baseThreshold = 19000;
    var isCartLocalized = (cart.currency && cart.currency !== "CHF");
    var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var displayCur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "CHF";
    
    var threshold = isCartLocalized ? Math.round(baseThreshold * rate) : baseThreshold;
    var total = cart.total_price;
    
    var pw = document.querySelector(".cart-drawer-progress-wrapper");
    if (!pw) return;
    
    var thresholdTextEl = pw.querySelector(".cart-drawer-progress-threshold");
    if (thresholdTextEl) {
      var displayThreshold = displayCur === "CHF" ? 190 : Math.round(190 * rate);
      thresholdTextEl.textContent = displayCur + " " + displayThreshold;
    }
    
    var amountEl = pw.querySelector(".cart-drawer-progress-amount");
    var awayEl = pw.querySelector(".cart-drawer-progress-away");
    var unlockEl = pw.querySelector(".cart-drawer-progress-unlocked");
    var barEl = pw.querySelector(".cart-drawer-progress-bar-fill");
    var dotEl = pw.querySelector(".cart-drawer-progress-dot");
    
    var pct = Math.min((total / threshold) * 100, 100);
    barEl.style.width = pct + "%";
    
    if (total >= threshold) {
      awayEl.style.display = "none";
      unlockEl.style.display = "inline";
      barEl.style.backgroundColor = "#3c7657";
      dotEl.style.backgroundColor = "#3c7657";
    } else {
      awayEl.style.display = "inline";
      unlockEl.style.display = "none";
      barEl.style.backgroundColor = "#c96b4b";
      dotEl.style.backgroundColor = "#c0c0c0";
      
      var away = (threshold - total) / 100;
      
      if (!isCartLocalized && displayCur !== "CHF") {
         away = away * rate;
      }
      
      amountEl.textContent = displayCur + " " + away.toFixed(2);
    }
  }

  // ─── Open / Close ─────────────────────────────────────────────────

  function openCart() {
    var form = document.querySelector(".w-commerce-commercecartform");
    if (form) form.style.display = "block";
    document.body.classList.add("cart-is-open");
    cartOpen = true;
    refreshCartCount();
  }

  function closeCart() {
    document.body.classList.remove("cart-is-open");
    cartOpen = false;
  }

  // ─── Boot ─────────────────────────────────────────────────────────

  ready(function () {
    if (!document.querySelector(".w-commerce-commercecartwrapper")) return;

    refreshCartCount();

    // Watch subtotal changes for progress bar
    var subtotalEl = document.querySelector(".w-commerce-commercecartordervalue");
    if (subtotalEl) {
      new MutationObserver(function () { refreshCartCount(); })
        .observe(subtotalEl, { childList: true, characterData: true, subtree: true });
    }

    // Refresh on tab focus
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) refreshCartCount();
    });

    // Bridge Udesly's native cart state events to our custom body classes
    document.addEventListener("wf-change-cart-state", function(e) {
      if (e.detail && e.detail.open === true) {
        openCart();
      } else if (e.detail && e.detail.open === false) {
        closeCart();
      }
    });

    // Click handlers
    document.addEventListener("click", function (e) {
      // Open
      if (e.target.closest(".cart-button")) {
        e.preventDefault();
        if (e.isTrusted === false) {
          openCart();
        } else {
          cartOpen ? closeCart() : openCart();
        }
        return;
      }
      // Close button
      if (e.target.closest(".close-button")) {
        e.preventDefault();
        closeCart();
        return;
      }
      // Backdrop click
      var wrapper = e.target.closest(".w-commerce-commercecartcontainerwrapper");
      var container = e.target.closest(".w-commerce-commercecartcontainer");
      if (wrapper && !container && cartOpen) {
        closeCart();
        return;
      }
      // Quantity +/-
      var minusBtn = e.target.closest(".feather-minus");
      var plusBtn = e.target.closest(".feather-plus");
      if (!minusBtn && !plusBtn) {
        var icon = e.target.closest(".icon-embed-xxsmall");
        if (icon) {
          minusBtn = icon.querySelector(".feather-minus");
          plusBtn = icon.querySelector(".feather-plus");
        }
      }
      var qtyWrap = e.target.closest(".cart_quantity-wrapper-nav");
      if (!qtyWrap || (!minusBtn && !plusBtn)) return;
      var input = qtyWrap.querySelector("input.w-commerce-commercecartquantity");
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      if (minusBtn && val > 0) {
        input.value = val - 1;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      } else if (plusBtn) {
        input.value = val + 1;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    // Prevent iOS background scroll when cart is open
    document.addEventListener("touchmove", function (e) {
      if (!cartOpen) return;
      var list = e.target.closest(".w-commerce-commercecartlist");
      if (!list) {
        if (e.cancelable) e.preventDefault();
      } else {
        list.style.overscrollBehaviorY = "contain";
      }
    }, { passive: false });

    // Neutralise Webflow's native cart handler
    if (window.Webflow && typeof window.Webflow.push === "function") {
      window.Webflow.push(function () {
        var w = document.querySelector('[data-node-type="commerce-cart-wrapper"]');
        if (w) w.setAttribute("data-node-type", "x-disabled");
        document.querySelectorAll('[data-node-type="commerce-cart-open-link"]').forEach(function (el) {
          el.setAttribute("data-node-type", "x-disabled");
        });
        document.querySelectorAll('[data-node-type="commerce-cart-close-link"]').forEach(function (el) {
          el.setAttribute("data-node-type", "x-disabled");
        });
      });
    }
  });
})();
